import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from 'layouts/auth-layout';
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from 'antd';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from 'configs/AppConfig'

export const Views = (props) => {
  const { locale, location } = props;
  
  // Ensure we have a valid locale, default to 'en' if not available
  const availableLocales = Object.keys(AppLocale);
  const validLocale = locale && availableLocales.includes(locale) ? locale : 'en';
  const currentAppLocale = AppLocale[validLocale];
 
  // Always ensure we have a valid app locale, fallback to 'en' if needed
  const finalAppLocale = currentAppLocale || AppLocale['en'];
  
  if (!currentAppLocale) {
    console.warn(`Locale ${validLocale} not found, falling back to 'en'`);
  }

  return (
    <IntlProvider
      locale={finalAppLocale.locale}
      messages={finalAppLocale.messages}
      defaultLocale="en">
      <ConfigProvider locale={finalAppLocale.antd}>
        <Switch>
          <Route exact path="/">
            <Redirect to={APP_PREFIX_PATH} />
          </Route>
          {/* <Route path={AUTH_PREFIX_PATH}>
            <AuthLayout />
          </Route> */}
          <Route path={APP_PREFIX_PATH}>
            <AppLayout location={location}/>
          </Route>
          <Route path="*">
            <AppLayout location={location}/>
          </Route>
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  )
}

const mapStateToProps = ({ theme, auth }) => {
  const { locale } =  theme;
  const { token } = auth;
  return { locale, token }
};

export default withRouter(connect(mapStateToProps)(Views));